import { useEffect } from 'react';
import { useAppDispatch } from '@/lib/redux/store';
import { useFetchSelf } from '@/containers/Accounts/api';
import useUser from './useUser';
import { setAppUser, setRootAccounts } from '@/lib/redux/app.slice';
import { AxiosError } from 'axios';
import useAuth from './useAuth';

const useInitializeFetchUser = () => {
  const dispatch = useAppDispatch();
  const { isLoggedIn, user, appUser } = useUser();
  const { handleLogout } = useAuth();
  const { isLoading, data, error } = useFetchSelf(isLoggedIn && !appUser);

  // Update redux
  useEffect(() => {
    if (!isLoading) {
      if (data?.data?.root_accounts) {
        dispatch(
          setAppUser({
            email: data.data.email,
            first_name: data.data.first_name,
            last_name: data.data.last_name,
            identities: data.data.identities,
            local_timezone: data.data.local_timezone,
            user_id: data.data.user_id,
            user_type: data.data.user_type,
            user_hash: data.data.user_hash,
          })
        );
        dispatch(setRootAccounts(data.data.root_accounts));
      } else if (error) {
        if ((error as AxiosError)?.response?.status === 401) {
          handleLogout();
        }
      }
    }
  }, [data, dispatch, isLoading, error, handleLogout, isLoggedIn, user]);
};

export default useInitializeFetchUser;
